import { ETypPrikazuDuvod } from 'services/dokumenty/prikazy';

export const duvodZruseniSelect = [
    {
        value: ETypPrikazuDuvod.SPLATNOST,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_SPLATNOST'
    },
    {
        value: ETypPrikazuDuvod.PREDSPL,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_PREDSPL'
    },
    {
        value: ETypPrikazuDuvod.LIKVIDACE,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_LIKVIDACE'
    },
    {
        value: ETypPrikazuDuvod.PREMENACP,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_PREMENACP'
    },
    {
        value: ETypPrikazuDuvod.PREMENASP,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_PREMENASP'
    },
    {
        value: ETypPrikazuDuvod.FUZE,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_FUZE'
    },
    {
        value: ETypPrikazuDuvod.ZMENOSOBA,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_ZMENOSOBA'
    },
    {
        value: ETypPrikazuDuvod.JINY,
        labelcz: 'PRIKAZ_ZRUSENI_DUVOD_JINY'
    }
];
